import type { Resource } from "i18next";

import type { AppLanguage } from "./config";
import { uzResources } from "./locales/uz";

// Default language is loaded eagerly (uz), others are lazy-loaded on demand
export const resources: Resource = {
  uz: uzResources,
};

const loaders: Partial<Record<AppLanguage, () => Promise<Resource[string]>>> = {
  "uz-cyrl": () => import("./locales/uz-cyrl").then((m) => m.uzCyrlResources),
  ru: () => import("./locales/ru").then((m) => m.ruResources),
  en: () => import("./locales/en").then((m) => m.enResources),
};

const loadedLanguages = new Set<string>(["uz"]);

export async function loadLanguageBundle(lang: AppLanguage): Promise<Resource[string] | null> {
  if (loadedLanguages.has(lang)) return null;
  const loader = loaders[lang];
  if (!loader) return null;
  const bundle = await loader();
  loadedLanguages.add(lang);
  return bundle;
}
